module.exports = __webpack_public_path__ + "img/plus.b121a385.svg";